import { GetTempleteDetails } from 'hooks'
import { ReasonPresetAdmin } from 'page-components/reason-presets'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { resolveReasonPresetTemplateId } from 'page-components/reason-presets/utils'

export const TemplateReasonPresetsScreen = () => {
    const { templateId } = useParams()
    const location = useLocation()
    const navigate = useNavigate()
    const { data: template, loading } = GetTempleteDetails(templateId)
    const numericId = resolveReasonPresetTemplateId(
        location.state?.templateNumericId,
        template?.Id,
        template?.unique_id,
        template?.UniqueId,
        template?.TemplateId,
        templateId,
    )

    return (
        <ReasonPresetAdmin
            templateId={numericId}
            templateName={
                location.state?.templateName || template?.TemplateName || ''
            }
            resolving={loading && !numericId}
            onBack={() => navigate('/app/templates')}
        />
    )
}
